import { useCallback, useEffect, useState } from "react";
import { authenticatedFetch } from "../utils/authenticatedFetch";

export const useCreditsSubscription = (
  userId: string | undefined,
  refreshTrigger: number
) => {
  const [credits, setCredits] = useState(0);
  const [creditsLoaded, setCreditsLoaded] = useState(false);
  const [subscriptionPlan, setSubscriptionPlan] = useState<string | null>(null);

  const loadCredits = useCallback(async () => {
    if (!userId) {
      setCreditsLoaded(true);
      return;
    }

    try {
      const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5001";
      const res = await authenticatedFetch(`${apiUrl}/api/credits/${userId}`);
      if (res.ok) {
        const data = await res.json();
        setCredits(data.credits ?? 0);
      }
    } catch (err) {
      console.error("Failed to fetch credits", err);
    }

    setCreditsLoaded(true);
  }, [userId]);

  const loadSubscription = useCallback(async () => {
    if (!userId) {
      setSubscriptionPlan(null);
      return;
    }

    try {
      const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5001";
      const res = await authenticatedFetch(`${apiUrl}/api/subscriptions/${userId}`);
      if (res.ok) {
        const data = await res.json();
        setSubscriptionPlan(data && data.status === "active" ? data.plan : null);
      }
    } catch (err) {
      console.error("Failed to fetch subscription", err);
    }
  }, [userId]);

  useEffect(() => {
    setCreditsLoaded(false);
    loadCredits();
    loadSubscription();
  }, [loadCredits, loadSubscription, refreshTrigger]);

  return {
    credits,
    creditsLoaded,
    loadCredits,
    loadSubscription,
    setSubscriptionPlan,
    subscriptionPlan,
  };
};
